import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import LookupTextLookupItemIdArray from '../../Elements/LookupTextLookupItemIdArray';

export default class CustomerSatisfactionServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'ProgramApproach',
      tabLabel: 'Program Approach',
      icon: 'fa-solid fa-diagram-project',
      data: [
        { name: (item) => Array.isArray(item.DistributionOfSurvey) ? item.DistributionOfSurvey.join(', ') : (item.DistributionOfSurvey || ''), label: 'Distribution of Survey' },
        { name: 'DistributionOfSurveyDetails', label: 'Please Describe' },
        { name: 'BareOrClientSend', label: 'Does BARE Send or Does the Client Send?' },
        { name: 'SmsorEmailForBare', label: 'If BARE Sends, SMS or Email?' },
        { name: 'FrequencyOfSurvey', label: 'Frequency of Survey?' },
        { name: 'TargetNumResponses', label: 'Target Number of Responses?' },
        { name: 'IncentivesDescription', label: 'Incentives (please describe)?' },
        { name: (item) => Array.isArray(item.B2borB2c) ? item.B2borB2c.join(', ') : (item.B2borB2c || ''), label: 'B2C, B2B, or Other?' },
      ],
    },
    {
      tabName: 'Survey',
      tabLabel: 'Survey',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.CollaborationInDataSoftware), label: 'Will Collaboration be Used in Data Software?' },
        { name: 'Mspplatform', label: 'MSP Platform' },
        { name: (item) => <LookupTextLookupItemIdArray lookupId={20} valueArray={item.RequiredLanguageCode} />, label: 'Required Language(s) Reporting' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
      ],
    },
    {
      tabName: 'TargetAudience',
      tabLabel: 'Target Audience',
      icon: 'fa-solid fa-bullseye',
      data: [
        { name: 'MinAge', label: 'Minimum Age' },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: (item) => <LookupText lookupId={17} value={item.GenderCode} />, label: 'Gender' },
        { name: 'OtherTargetAudienceRequirements', label: 'Other Target Audience Requirements' },
        { name: (item) => <LookupText lookupId={18} value={item.MaritalStatusCode} />, label: 'Marital Status' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
